var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-flex is-align-items-center"},[_c('img',{staticClass:"is_hot operation_icon",attrs:{"src":_vm.getSelectedImage()},on:{"click":function($event){return _vm.toggle()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }